export default __webpack_public_path__ + "static/media/flag_fr.d7acb86a.svg";